import { useState } from "react";
import { createPortal } from "react-dom"; // ADD THIS

export const ImageZoom = ({
  src,
  alt = "Attachment",
  thumbnailClassName = "",
  imageClassName = "max-h-[50px]"
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!src) return null;

  return (
    <>
      {/* Thumbnail */}
      <div
        className={`relative group cursor-zoom-in overflow-hidden rounded-lg shadow-md border border-gray-200 bg-white inline-block ${thumbnailClassName}`}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(true);
        }}
      >
        <img
          className={`object-contain max-w-full h-auto block transition-transform duration-500 group-hover:scale-110 ${imageClassName}`}
          src={src}
          alt={alt}
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
          <div className="opacity-0 group-hover:opacity-100 transform translate-y-1 group-hover:translate-y-0 transition-all bg-white/90 text-gray-800 px-2 py-1 rounded text-[10px] font-bold shadow-lg uppercase tracking-tighter">
            View
          </div>
        </div>
      </div>

      {/* ✅ Portal renders OUTSIDE the modal's stacking context, directly to <body> */}
      {isOpen && createPortal(
        <div
          className="fixed inset-0 flex items-center justify-center bg-black/95 p-4 cursor-pointer backdrop-blur-sm"
          style={{ zIndex: 999999 }} // inline style ensures it's not trapped by any parent
          onClick={() => setIsOpen(false)}
        >
          <div className="relative max-w-5xl max-h-[90vh] flex flex-col items-center">
            <img
              src={src}
              alt="Full view"
              className="max-w-full max-h-[80vh] rounded shadow-2xl object-contain border border-white/10"
            />
            <button className="mt-8 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 border border-white/20 px-8 py-2.5 rounded-full transition-all text-sm font-medium cursor-pointer">
              Close Preview
            </button>
          </div>
        </div>,
        document.body // ✅ Renders directly on body, escaping all stacking contexts
      )}
    </>
  );
};